import { FireIcon } from "@heroicons/react/outline";
import { getFileExt } from "../../../../utils/products/utils_products";
import { useProductImage } from "../../../../lib/hooks/use-product-image";
import { CartProduct } from "../types/cart.types";

interface CartItemImageProps {
  product: CartProduct;
}

export const CartItemImage = ({ product }: CartItemImageProps) => {
  const { WDCatalogImage, WDCatalogImageFileName, isLoading } = useProductImage(
    product.eCommerceURL
  );
  const ext = getFileExt(product.WDCatalogImageFileName || WDCatalogImageFileName);

  return (
    <div className="flex-shrink-0 w-24 h-24 border border-gray-200 rounded-md overflow-hidden p-2">
      {WDCatalogImage ? (
        <img
          src={`data:image/${ext};base64,${WDCatalogImage}`}
          alt={product.eCommerceStoreName}
          className="w-full h-full object-center object-cover"
        />
      ) : isLoading ? (
        <div className="w-full h-full animate-pulse bg-gray-100 rounded" />
      ) : (
        <FireIcon className="w-full h-full object-center object-cover p-4" />
      )}
    </div>
  );
};
